import { ShieldCheck } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

interface SetPinPromptProps {
  /** The `redirect` query param, e.g. "/payments/bills/data". */
  redirect: string;
  /** Verb phrase, e.g. "buying data", "paying for electricity". */
  action: string;
}

/** Shared "set a transaction PIN first" gate used by every bill page. */
const SetPinPrompt = ({ redirect, action }: SetPinPromptProps) => (
  <div className="px-5 py-12 flex items-center justify-center">
    <div className="bg-white border border-gray-200 rounded-2xl p-8 max-w-lg text-center flex flex-col gap-5 items-center shadow-sm">
      <div className="w-16 h-16 rounded-full bg-visaro-orange/10 text-visaro-orange flex items-center justify-center">
        <ShieldCheck size={32} weight="bold" />
      </div>
      <div>
        <h2 className="text-2xl font-bold text-gray-900">
          Set your transaction PIN
        </h2>
        <p className="text-gray-500 mt-2">
          You need a 4-digit transaction PIN before {action}. This keeps wallet
          payments secure.
        </p>
      </div>
      <Link
        to={`/pin/setup?redirect=${redirect}`}
        className="p-3 px-6 rounded-xl bg-deepBlue text-white font-medium"
      >
        Set Transaction PIN
      </Link>
    </div>
  </div>
);

export default SetPinPrompt;
